export const MISSING_DATA_PLACEHOLDER = 'No information';
